import React from 'react';

import { Typography } from '../../../../components/Wrappers/Wrappers';
import { useStyles } from './aboutSection.styles';

const VALUES = [
    {
        n: '01',
        h: 'Audience segmentation',
        p: 'In CDPs like StellarAlgo or Cortex, create detailed audience segments for more specific targeting, e.g.: "Female calendar users who are Family Organisers, live in New York, follow the Yankees, and have a high Purchase Intent for Tickets".',
    },
    {
        n: '02',
        h: 'Lookalike audiences',
        p: 'In advertising platforms like Meta and TikTok, use your ECAL audience to create lookalike audiences for more effective advertising campaigns to target high-value consumers, at a far lower cost.',
    },
    {
        n: '03',
        h: "'Next best action' offers",
        p: "In AI platforms like Claude, Gemini, OpenAI or Perplexity, create automated workflows for 'next best action' to send highly targeted, personalised offers to consumers, such as a merchandise offer, premium upgrade, or experience recommendation.",
    },
];

function ConnectAboutSection () {
    const classes = useStyles();

    return (
        <div>
            <Typography variant="h5" weight="bold" style={{ fontSize: 22 }}>What's possible with Connect?</Typography>
            <Typography variant="body2" className={classes.lede}>
                Connect your ECAL audience to your data lake, so you have everything conveniently in one
                place. Or send it to your CDP for segmentation, email program for follow-on messaging, or
                to your primary marketing platform for direct-to-calendar campaigns, or sophisticated
                multi-channel journeys. Sync it to your advertising suite to create 'lookalike' audiences,
                or to your favourite AI to create some truly magical workflows. Here's a few ideas to get
                you thinking!
            </Typography>

            <div className={classes.grid}>
                {VALUES.map((value) => (
                    <div key={value.n} className={classes.value}>
                        <span className={classes.num}>{value.n}</span>
                        <Typography variant="subtitle1" weight="bold">{value.h}</Typography>
                        <Typography variant="body2" className={classes.text}>{value.p}</Typography>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default ConnectAboutSection;
